var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.btnClicked}},[_vm._v("ایجاد سند حسابداری")])])}
var staticRenderFns = []

export { render, staticRenderFns }